<template>
  <div v-loading="isLoading">
    <el-row>
      <el-card shadow="never">
        <el-row>
          <el-col :span="6">
            <div>
              <h2>Company Information</h2>
              <p><strong>{{ `${account.name || '-'}` }}</strong></p>
              <p>
                <router-link :to="{ name: 'manage-accounts-account-details', params: { accountId: $_.get(account, 'parent.id') }}">
                  {{ `${$_.get(account, 'parent.name', '')}` }}
                </router-link>
              </p>
              <p><strong>Address: </strong>{{ `${account.address || ''} ${account.suburb || ''} ${account.state || ''} ${account.postcode || ''}` }}</p>
              <p><strong>Phone: </strong><a :href="`tel:${account.phone || '-'}`">{{ `${account.phone || '-'}` }}</a></p>
              <p><strong>Fax: </strong>{{ `${account.fax || '-'}` }}</p>
              <p><strong>Email: </strong>{{ `${account.email || '-'}` }}</p>
              <p>
                <b>Account Grade: </b>
                <span>
                  <el-tag
                    :type="getGradeTagType($_.get(account, 'crm_account_grade'))"
                    size="mini"
                  >
                    {{ getGradeDescription($_.get(account, 'crm_account_grade')) }}
                  </el-tag>
                </span>
              </p>
              <p>
                <b>Status: </b>
                <span>{{ getEndangeredStatus($_.get(account, 'crm_endangered')) }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <h2>Billing</h2>
            <p><strong>Billing Code: </strong>{{ `${account.billing_myob_id || '-'}` }}</p>
            <p><strong>ABN: </strong>{{ `${account.billing_abn || '-'}` }}</p>
            <p><strong>Business Group: </strong>{{ $_.get(account, 'b_group.long', '-') }}</p>
          </el-col>
          <el-col :span="6">
            <h2>Sales Rep</h2>
            <p><strong>Name: </strong>{{ `${$_.get(account, 'portfolio.profile.name_display') ? $_.get(account, 'portfolio.profile.name_display') : $_.get(account, 'portfolio.profile.name_full', '-') }` }}</p>
            <p><strong>Phone: </strong><a :href="`tel:${$_.get(account, 'portfolio.profile.phone_primary', '-')}`">{{ `${$_.get(account, 'portfolio.profile.phone_primary', '-')}` }}</a></p>
            <p v-if="$_.get(account, 'portfolio.profile.phone_secondary')">
              <strong>Secondary: </strong><a :href="`tel:${$_.get(account, 'portfolio.profile.phone_secondary', '-')}`">{{ `${$_.get(account, 'portfolio.profile.phone_secondary', '-')}` }}</a>
            </p>
            <p v-else>
              <strong>Secondary: </strong> -
            </p>
            <p>
              <strong>Email: </strong>
              <a
                target="_new"
                :href="`mailto:${$_.get(account, 'portfolio.profile.email', '-')}`"
              >{{ `${$_.get(account, 'portfolio.profile.email', '-')}` }}</a>
            </p>
            <p>
              <strong>Location: </strong>{{ `${$_.get(account, 'portfolio.profile.time_zone') ? getLocationFromTimezone($_.get(account, 'portfolio.profile.time_zone')) : '-' }` }}
            </p>
          </el-col>
          <el-col :span="6">
            <h2>Investigator</h2>
            <p><strong>Name: </strong>{{ `${$_.get(account, 'investigator.name_display') ? $_.get(account, 'investigator.name_display') : $_.get(account, 'investigator.name_full', '-') }` }}</p>
            <p><strong>Phone: </strong><a :href="`tel:${$_.get(account, 'investigator.phone_primary', '-')}`">{{ `${$_.get(account, 'investigator.phone_primary', '-')}` }}</a></p>
            <p v-if="$_.get(account, 'investigator.phone_secondary')">
              <strong>Secondary: </strong><a :href="`tel:${$_.get(account, 'investigator.phone_secondary', '')}`">{{ `${$_.get(account, 'investigator.phone_secondary', '')}` }}</a>
            </p>
            <p v-else>
              <strong>Secondary: </strong> -
            </p>
            <p>
              <strong>Email: </strong>
              <a
                target="_new"
                :href="`mailto:${$_.get(account, 'investigator.email', '-')}`"
              >{{ `${$_.get(account, 'investigator.email', '-')}` }}</a>
            </p>
            <p>
              <strong>Location: </strong>{{ `${$_.get(account, 'investigator.time_zone') ? getLocationFromTimezone($_.get(account, 'investigator.time_zone')) : '-' }` }}
            </p>
          </el-col>
        </el-row>
        <el-divider />
        <el-row>
          <el-col :span="12">
            <h2>About {{ account.name }}</h2>
            <pre
              class="companyInfo"
            >
              {{ account.information }}
            </pre>
          </el-col>
          <el-col :span="12">
            <iframe
              width="100%"
              height="400"
              style="border:0"
              loading="lazy"
              allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"
              :src="mapURL"
            />
          </el-col>
        </el-row>
      </el-card>
    </el-row>
  </div>
</template>

<script>

export default {
  data () {
    return {
      accountId: this.$route.params.accountId,
      account: {},
      isLoading: false,
      breadcrumb: {
        name: 'Details',
        route: { name: 'manage-accounts-account-details', params: { accountId: this.$route.params.accountId } }
      },
      actions: [
        {
          hidden: false,
          name: 'Customer Service',
          icon: ['fal', 'arrow-left'],
          event: () => {
            this.$router.push({
              name: 'customerservice-accounts-account',
              params: { accountId: this.$route.params.accountId }
            })
          }
        }
      ]
    }
  },
  computed: {
    mapURL: function () {
      return 'https://www.google.com/maps/embed/v1/place?key=AIzaSyAkmy7mQvol6qNzwI8gsUKWizT0j8OeiIM&q=' + this.account.address + ' ' + this.account.suburb + ' ' + this.account.state
    }
  },
  created () {
    this.loadAccount()
    console.log(this.$_.get(this.account, 'investigator.phone_secondary', '-'))
  },
  methods: {
    getLocationFromTimezone (timezone) {
      if (timezone.zone && timezone.zone.length) {
        return timezone.zone.split('/').reverse().join(', ')
      }

      return '-'
    },
    loadAccount () {
      this.isLoading = true
      this.$sdk.account.read(this.accountId, builder => {
        builder.include = ['acc_type', 'b_group', 'crm_ac_type', 'metas', 'parent', 'portfolio.profile', 'stationary_type', 'asset_histories.asset.manufacturer_model.manufacturer', 'trading_term', 'time_cycle', 'investigator']
      }).then(res => {
        this.account = res
      }).finally(() => { this.isLoading = false })
    },
    getGradeTagType (grade) {
      switch (grade) {
        case 1:
        case 6:
          return 'success'
        case 2:
        case 3:
          return 'warning'
        case 4:
          return 'danger'
        case 5:
        default:
          return 'info'
      }
    },
    getGradeDescription (grade) {
      switch (grade) {
        case 1:
          return 'A'
        case 2:
          return 'B'
        case 3:
          return 'C'
        case 4:
          return 'D'
        case 6:
          return 'HC'
        case 5:
        default:
          return 'No Trade'
      }
    },
    getEndangeredStatus (status) {
      switch (status) {
        case -1:
          return 'New'
        case 0:
          return 'Healthy'
        case 1:
        default:
          return 'Endangered'
      }
    }
  }
}
</script>
<style>
  .companyInfo {
    white-space: pre-wrap;
    font-family: inherit;
  }
</style>
